import styled from 'styled-components';

export const ErrorMessageTextStyled = styled.div`
  color: red;
  font-weight: 400;
  width: 100%;
  padding-top: 12px;
`;
